import { effect, inject, Injectable } from '@angular/core';
import { Tenant } from '../../core/models/tenant';
import { WhoisUserService } from '../../auth/services/whois-user.service';
import { localStorageSignal } from '../../core/utils/localStorageSignal';

@Injectable({
  providedIn: 'root',
})
export class AsTenantService {
  private wis = inject(WhoisUserService);

  private _selectedTenant = localStorageSignal<Tenant.Tenant | null>(null, 'selected-tenant');

  constructor() {
    effect(() => {
      // on logout reset the selected tenant
      if (this.wis._user() === null) {
        this._selectedTenant.set(null);
      }
    });
  }

  public selectedTenant() {
    return this._selectedTenant;
  }
}
